import React, { useEffect, useRef, useState } from "react";
import DeleteItem from "../../../../../Partials/Layouts/DeleteItem/DeleteItem";
import { CHANGED_INVENTORIES_API } from "../../../../../../Utilities/APIs/APIs";
import Modal from "../../../../../Partials/Elements/Modal/Modal";
import CreateButton from "../../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import CRUDTable from "../../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDth from "../../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableHeader from "../../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDTableRow from "../../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import ShortTextCell from "../../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import ViewButton from "../../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton";
import CreateChangedInventories from "./CreateChangedInventories";
import ViewChangedInventories from "./ViewChangedInventories";
import UpdateChangedInventories from "./UpdateChangedInventories";
import { useParams } from "react-router-dom";

function ChangedInventories() {
  const [changedInventories, setChangedInventories] = useState([]);
  const [counts, setCounts] = useState({}); 
  const screenHeaerRef = useRef();
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    if (screenHeaerRef.current) {
      setScreenHeaderHeight(screenHeaerRef.current.clientHeight);
    }
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);

  const [targetID, setTargetID] = useState(null);
  const axiosInstance = useAxiosInstance();
  const { id } = useParams();

  const apiBase = (axiosInstance?.defaults?.baseURL || '').replace(/\/+$/, '');

  useEffect(() => {
    async function load() {
      try {
        // 1) load change rows (legacy API)
        const { data } = await axiosInstance.get(
          CHANGED_INVENTORIES_API + 'getChangedInventories/' + id
        );
        const rows = Array.isArray(data) ? data : [];
        setChangedInventories(rows);

        // 2) ask stockUnits for counts in ONE call
        if (rows.length) {
          const ids = rows.map(r => r._id).join(',');
          const { data: agg } = await axiosInstance.get(
            `/inventory/stockUnits/counts/by-changes`,
            { params: { ids } }
          );
          const map = {};
          (agg || []).forEach(({ changeRef, count }) => { map[changeRef] = count; });
          setCounts(map);
        } else {
          setCounts({});
        }
      } catch {
        setChangedInventories([]);
        setCounts({});
      }
    }
    load();
  }, [id, toggleFetch, axiosInstance, apiBase]);

  function triggerFetch() { setToggleFetch(p => !p); }

  function locationLabel(v) {
    if (v === 'mainOffice') return 'Main Office';
    if (v === 'showRoom')   return 'Showroom';
    if (v === 'wareHouse')  return 'Warehouse';
    return '—';
    }

  return (
    <>
      <div className="screen_header" ref={screenHeaerRef}>
        <h1 className="screen_heading">
          Changed Inventories ({changedInventories.length} in total)
        </h1>
        <CreateButton
          screenTopicSingular={"Changed Inventories"}
          setShowCreateForm={setShowCreateForm}
        />
      </div>

      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th="Quantity" />
          <CRUDth th="Date" />
          <CRUDth th="Change Type" />
          <CRUDth th="Location" />
          <CRUDth th="Barcodes" />
          <CRUDth th="Action" />
        </CRUDTableHeader>
        <tbody>
          {changedInventories.map(row => (
            <CRUDTableRow key={row._id}>
              <ShortTextCell text={row.quantity} />
              <ShortTextCell text={new Date(row.date).toLocaleDateString()} />
              <ShortTextCell text={row.changeType} />
              <ShortTextCell text={locationLabel(row.productLocation)} />
              <ShortTextCell text={counts[row._id] ?? 0} />

              <td>
                <div className="action_buttons_wrapper">
                  <div className="action_buttons">
                    <ViewButton
                      setShowViewSection={setShowViewSection}
                      targetID={row._id}
                      setTargetID={setTargetID}
                    />
                    <button
                      className="crud_btn"
                      onClick={() => { setTargetID(row._id); setShowUpdateForm(true); }}
                      type="button"
                      title="Edit"
                    >
                      ✎
                    </button>
                  </div>
                </div>
              </td>
            </CRUDTableRow>
          ))}
        </tbody>
      </CRUDTable>

      {showCreateForm && (
        <Modal extraClass={"small"} modalHeading={`Add Inventories`} setShowModalContent={setShowCreateForm}>
          <CreateChangedInventories id={id} triggerFetch={triggerFetch} setShowCreateForm={setShowCreateForm} />
        </Modal>
      )}

      {showUpdateForm && (
        <Modal extraClass={"small"} modalHeading={`Update Inventories`} setShowModalContent={setShowUpdateForm}>
          <UpdateChangedInventories triggerFetch={triggerFetch} targetID={targetID} setShowUpdateForm={setShowUpdateForm} />
        </Modal>
      )}

      {showViewSection && (
        <Modal extraClass={"large"} modalHeading={`View Inventories`} setShowModalContent={setShowViewSection}>
          <ViewChangedInventories targetID={targetID} />
        </Modal>
      )}

      {showDeleteSection && (
        <Modal extraClass={"small"} modalHeading={`Delete Inventories`} setShowModalContent={setShowDeleteSection}>
          <DeleteItem api={CHANGED_INVENTORIES_API} triggerFetch={triggerFetch} targetID={targetID} setShowDeleteItem={setShowDeleteSection} />
        </Modal>
      )}
    </>
  );
}
export default ChangedInventories;
